import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  DialogContentText,
  Box,
  Typography,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import CustomIconButton from "../../../../Components/CustomIconButton";
import CustomContainedButton from "../../../../Components/CustomContainedButton";
import { ArrowBack, ArrowRight } from "@mui/icons-material";
import { ObjectValues } from "../../../login";

type ContentConfirmationDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (validator_remark: string) => void;
  actionType: "corrected" | "noChange"; // New prop to determine the action type
  row?: any; // Optional row data
  isSubmitting: boolean;
  newPath: ObjectValues;
  filters: ObjectValues;
};

const ContentConfirmationDialog: React.FC<ContentConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  actionType,
  newPath,
  filters,
  isSubmitting,
}) => {
  const [remark, setRemark] = useState("");
  // const [notifyUsers, setNotifyUsers] = useState(false);

  const handleConfirm = () => {
    onConfirm(remark);
  };

  useEffect(() => {
    setRemark("");
  }, [open]);
  return (
    <Dialog
      sx={{
        "& .MuiDialog-container": {
          backdropFilter: "blur(3px)", // subtle blur
        },
      }}
      open={open}
      onClose={(event, reason) => {
        if (isSubmitting) {
          return;
        }
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      BackdropProps={{
        style: { pointerEvents: isSubmitting ? "none" : "auto" },
      }}
    >
      <DialogTitle>
        {actionType === "corrected"
          ? "Mark as Corrected"
          : "No Changes Required"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Typography variant="body2" sx={{ mt: 1 }}>
              <em>Note:</em>{" "}
             <strong>
  Any change to the question will be visible across all the exams where it is used.
</strong><br/>
              Once submitted, this update to question will be{" "}
              <strong>published </strong>
              and immediately <strong> visible in the NetPractice app.</strong>
              Please review carefully before proceeding.
            </Typography>{" "}
            <Typography> Please enter a remark</Typography>
          </Box>
        </DialogContentText>
        <Stack
          spacing={2}
          style={{
            marginTop: "10px",
            pointerEvents: isSubmitting ? "none" : "auto",
          }}
        >
          <TextField
            label={
              actionType === "corrected"
                ? "Remark on Changes"
                : "Explanation for No Changes"
            }
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            multiline
            rows={4}
            fullWidth
          />
          {/* {actionType === "corrected" ? (
            <Stack>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={notifyUsers}
                    onChange={(e) => setNotifyUsers(e.target.checked)}
                    style={{ color: "#000000" }}
                  />
                }
                label="Send notification to all users who have attempted this question"
              />
            </Stack>
          ) : (
            <></>
          )} */}
        </Stack>
      </DialogContent>
      <DialogActions>
        <CustomIconButton
          variant="outlined"
          content={"Cancel"}
          sx={{ minWidth: "fit-content", mr: "5px" }}
          onClick={onClose}
          icon={<ArrowBack sx={{ height: "16px" }} />}
          disabled={isSubmitting}
        />
        <CustomContainedButton
          otherProps={{
            disabled: isSubmitting,
            onClick: handleConfirm,
            sx: { minWidth: "60px" },
          }}
          icon="Submit"
          content={<PlaylistAddCheckOutlinedIcon sx={{ height: "16px" }} />}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ContentConfirmationDialog;
